import styled from "styled-components";
import checkSuccessBadge from "assets/icons/checkSuccessBadge.svg";
import checkDangerBadge from "assets/icons/checkDangerBadge.svg";
import closeIcon from "assets/icons/close_circle.svg";
import Spacer from "./Spacer";
import { connect } from "react-redux";
import { setAlertDetails } from "api";

const Wrapper = styled.div`
  position: fixed;
  right: 2.4rem;
  top: 9.6rem;
  min-height: 5.6rem;
  min-width: 37rem;
  padding: 0.8rem 2.4rem;
  background-color: #ffffff;
  box-shadow: 0px 0px 25px 0px #0000000d;
  border-left: 8px solid;
  border-radius: 8px;
  width: max-content;
  transition: all 500ms ease-out;
  z-index: 23456;

  &.hide {
    opacity: 0;
    pointer-events: none;
    right: -100rem;
  }

  .closeBtn {
    position: absolute;
    right: 2.4rem;
    height: 2.4rem;
  }

  &.success {
    border-color: var(--success);
  }

  &.danger {
    border-color: var(--danger);
  }

  @media screen and (max-width: 768px) {
    min-width: unset;
    width: calc(100vw - 4.8rem);
    padding: 0.8rem 1.2rem;
  }
`;

const AlertBox = ({ className, alert_details }) => {
  const handleClose = () => setAlertDetails(null)

  return (
    <Wrapper
      className={`${className ?? ""} ${
        alert_details?.type ?? "hide"
      } flexRow alignCenter success`}
    >
      {alert_details?.type === true && (
        <img src={checkSuccessBadge} alt="check success" />
      )}
      {alert_details?.type === "danger" && (
        <img src={checkDangerBadge} alt="check danger" />
      )}
      <Spacer x={1.2} />
      <span className="l2 colorGrey1">{alert_details?.msg}</span>
      <Spacer x={5.2} />
      <button className="closeBtn" onClick={handleClose}>
        <img src={closeIcon} alt="close" className="icon" />
      </button>
    </Wrapper>
  );
};

const mapStateToProps = (state) => {
  return {
    alert_details: state.alert_details,
  };
};

export default connect(mapStateToProps)(AlertBox);
